// src/pages/Admin/TableauDeBordAdherents/utils/adminDashboardUtils.js

export function safeJsonParse(value, fallback = null) {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function getStoredUserInfo() {
  return safeJsonParse(localStorage.getItem("userInfo"), null);
}

export function getUserRoleId(user) {
  return Number(
    user?.role_id ??
      user?.roleId ??
      user?.role?.id ??
      user?.Role?.id ??
      user?.user_role_id ??
      0
  );
}

export function scrollToSection(sectionId) {
  if (!sectionId) return;

  const target = document.getElementById(sectionId);

  if (!target) return;

  target.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}